import React from "react";

const ToggleSwitch = ({ name, checked, onChange }) => {
  return (
    <div
        name={name}
        className={`relative w-10 h-6 rounded-full flex items-center px-1 cursor-pointer transition-all duration-300
            ${checked ? "bg-green-500" : "bg-neutral-400"}`}
        onClick={() => onChange(!checked)}
    >
      {/* Circle (Switch Handle) */}
      <div
        className={`w-4 h-4 bg-white rounded-full shadow-md transform transition-all duration-300
          ${checked ? "translate-x-4" : "translate-x-0"}`}
      />
    </div>
  );
};

export default ToggleSwitch;
